// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1VKQ-","subheader":"ReorderModal_subheader__3pFKX","listWrap":"ReorderModal_listWrap__4kx4g"};